import React,{Fragment} from "react";
import Modal from "../../layout/Modal";
import PropTypes from "prop-types";

class AskBeforeUnload extends React.Component {

    static propTypes = {
        buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
        saveable: PropTypes.bool
    }

    render() {
        return <Modal
            ref={(modal) => this.modal = modal}
            state={this.props.buttons ? "on" : "off"}
            theme={"default"}
            header={this.props.saveable === undefined || this.props.saveable === true ? "Mentés" : "Elvetés"}
            buttons={this.props.buttons || []}
        >
            {this.props.saveable === undefined || this.props.saveable === true ?
                <Fragment>Akarod menteni a változtatásokat?</Fragment> :
                <Fragment>Biztos elveted a változtatásokat?</Fragment>}
        </Modal>;
    }
} 
export default AskBeforeUnload;